import React, { useState, useEffect } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from "react-i18next";
import TechnoIcon from "../components/TechnoIcon.js";
import { SlArrowLeft, SlCursor } from "react-icons/sl";

const ProjectDetails = ({ id }) => {
  const { t } = useTranslation();
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    const projetsData = t("projects", { returnObjects: true }); 
    const projet = projetsData.find((p) => p.id === parseInt(id));
    setDetail(projet);
  }, [id, t]);

  if (!detail) {
    return <div className="container marginTop">{t("loading")}</div>;
  }

  return (
    <div className="container marginTop">
      <div className="retour">
        <span className="retourIcon"><SlArrowLeft /></span>
        <a className="retour" href="/projets" >{t("back")}</a>
      </div>
      <h1 className="titreProjet">{detail.title}</h1>
      <h5 className="coursEtDate">
        <span className="bleu">{detail.cours}</span> | {detail.date}
      </h5>
      <div className="row">
        <div className="col-lg-6 col-12">
          <img
            src={require(`./../assets/${detail.images[0]}`)}
            className="mainImage"
            alt={detail.title}
          />
        </div>
        <div className="col-lg-6 col-12">
          <div className="backgroundColor">
            <h4 className="fw-bold">{t("technos")}</h4>
            <div>
              {detail.technos.map((techno, index) => (
                <TechnoIcon key={index} techno={techno} />
              ))}
            </div>
            <div className="technosBorder mb-5 pt-3"></div>
            <p>{detail.description}</p>
            {detail.link && (
              <div className="lien">
                <a href={detail.link}>{t("voir.site")}</a> <SlCursor />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="row gy-0">
        {detail.images.slice(1).map((img, index) => (
          <div key={index} className="col-lg-6 col-12 autresImages">
            <img
              src={require(`./../assets/${img}`)}
              className="mainImage"
              alt={`${detail.title} ${index + 1}`}
            />
          </div>
        ))}
      </div>
      {detail.video && (
        <div className="row mt-4 g-0">
          <div className="col-12 d-flex flex-column align-items-center fondVideo">
            <h5 className="mb-3">{t("survol")}</h5>
            <video src={require(`./../assets/${detail.video}`)} controls>
              {t("not.supported")}
            </video>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjectDetails;
